namespace Areas.Account.YearMonthGLChart {
    "use strict";


    export function onLegendClick(e) {
        var arg = e.target;
        toggleVisibility(arg);
    }

    function toggleVisibility(item) {
        if (item.isVisible()) {
            item.hide();
        } else {
            item.show();
        }
    }

    export function customizeLabels() {
        return { visible: false };
    }

    export function chartRedraw() {
        const chart = $("#GLChart").dxChart("instance");
        var series = chart.getAllSeries();
        //TODO  figure out all label visibility/not visible
  /*      chart.option(")*/
        var a = 1;

    }

}
